import { render, staticRenderFns } from "./DetailTermin.vue?vue&type=template&id=18f145f5&"
import script from "./DetailTermin.vue?vue&type=script&lang=js&"
export * from "./DetailTermin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports